import "react-toastify/dist/ReactToastify.css";

import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import CancelIcon from "@mui/icons-material/Cancel";

import { arbitratorAdd, arbitratorEdit } from "../../adapter/arbitratorAdapter";
import GoBack from "../../components/GoBack";
import { getEnterprise } from "../../adapter/EnterpriseAdapter";
import axios from "axios";
import { baseUrlForEnterprise } from "../../variables/variables";
import { CleaningServices } from "@mui/icons-material";

function ArbitatorSave() {
  const state = useLocation().state;
  const navigate = useNavigate();
  const theme = useTheme();
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(state ? state[0].id : "");
  const [data, setData] = useState([]);
  const [selectedBlockedEnterprises, setSelectedBlockedEnterprises] = useState(
    []
  );

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      pseudonym: state ? state[0].pseudonym : "",
      category: state ? state[0].category : "",
      availabilityClass: state ? state[0].availabilityClass : "",
      blockedEnterprises: state ? state[0].blockedEnterprises : "",
    },
  });

  const onSubmit = (data) => {
    data.blockedEnterprises = selectedBlockedEnterprises;
    setLoading(true);
    if (state) {
      const info = arbitratorEdit(id, data);

      info.then((result) => {
        setLoading(false);
        handleSubmissionResult(result);
      });
    } else {
      const info = arbitratorAdd(data);
      info.then((result) => {
        setLoading(false);
        handleSubmissionResult(result);
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    const settings = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    axios
      .get(baseUrlForEnterprise, settings)
      .then((res) => {
        if (res.data.status !== "success") {
          setLoading(false);
          toast.error("Something went wrong !");
          setData([]);
          return;
        }
        const mydata = res.data.data.map((item) => item.name);
        setData(mydata);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message);
        setData([]);
        return;
      });
  }, []);

  const handleSubmissionResult = (result) => {
    if (result.status === "success") {
      navigate("/app/arbitrators");
      toast.success(result.message);
    } else {
      toast.error(result.message);
      reset();
    }
  };

  const handleChange = (event) => {
    setSelectedBlockedEnterprises(event.target.value);
  };

  const resrthandle = () => {
    reset();
  };
  const handleDelete = (valueToDelete) => {
    setSelectedBlockedEnterprises((chips) =>
      chips.filter((chip) => chip !== valueToDelete)
    );
  };
  return (
    <div className="navView">
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <HashLoader color="#FBB04C" />
      </Backdrop>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 className="component-title">Create Arbitrator</h2>
          <GoBack />
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="formStyle">
            <div className="formItem">
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Arbitrator ID"
                  variant="outlined"
                  type="text"
                  name="pseudonym"
                  {...register("pseudonym", {
                    required: {
                      value: true,
                      message: "Any Arbitrator ID is required!",
                    },
                  })}
                  error={Boolean(errors.pseudonym)}
                  helperText={errors.pseudonym?.message}
                />
              </FormControl>
            </div>
            <div className="formItem">
              <FormControl fullWidth>
                <Autocomplete
                  options={["C2", "C1", "B", "A3", "A2", "A1", "HC"]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      id="outlined-basic"
                      label="Category"
                      variant="outlined"
                      type="text"
                      name="category"
                      {...register("category", {
                        required: {
                          value: true,
                          message: "Category is required!",
                        },
                      })}
                    />
                  )}
                  getOptionSelected={(option, value) => option === value}
                />
              </FormControl>
            </div>
            <div className="formItem">
              <FormControl fullWidth>
                <InputLabel id="availability-label">Availability</InputLabel>
                <Select
                  labelId="availability-label"
                  id="availability"
                  label="Availability"
                  name="availabilityClass"
                  {...register("availabilityClass", {
                    required: {
                      value: true,
                      message: "Availability is required!",
                    },
                  })}
                  error={Boolean(errors.availabilityClass)}
                  helperText={errors.availabilityClass?.message}
                >
                  <MenuItem value="0">0. No availability</MenuItem>
                  <MenuItem value="1">1. Restricted availability</MenuItem>
                  <MenuItem value="2">2. Limited availability</MenuItem>
                  <MenuItem value="3">3. Moderate availability</MenuItem>
                  <MenuItem value="4">4. Sufficient availability</MenuItem>
                  <MenuItem value="5">5. Total availability</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="formItem">
              <FormControl>
                <InputLabel id="demo-multiple-chip-label">
                  Blocked Enterprises
                </InputLabel>
                <Select
                  labelId="demo-multiple-chip-label"
                  id="demo-multiple-chip"
                  multiple
                  value={selectedBlockedEnterprises}
                  onChange={handleChange}
                  input={
                    <OutlinedInput
                      id="select-multiple-chip"
                      label="Blocked Enterprises"
                    />
                  }
                  renderValue={(selected) => (
                    <Stack gap={1} direction="row" flexWrap="wrap">
                      {selected.map((value) => (
                        <Chip
                          key={value}
                          label={value}
                          onDelete={() => handleDelete(value)}
                          deleteIcon={
                            <CancelIcon
                              onMouseDown={(event) => event.stopPropagation()}
                            />
                          }
                        />
                      ))}
                    </Stack>
                  )}
                  MenuProps={MenuProps}
                >
                  {data.map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="formButtons-block">
            <Button
              startIcon={<SaveIcon />}
              disabled={loading}
              type="submit"
              variant="contained"
              sx={{ mt: 2, mb: 2 }}
              style={{
                background:
                  "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
              }}
            >
              {state ? "Update" : "Save"}
            </Button>
            <Button
              startIcon={<RotateLeftIcon />}
              style={{
                background:
                  "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
              }}
              variant="contained"
              sx={{ mt: 2, mb: 2 }}
              onClick={resrthandle}
            >
              Reset
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ArbitatorSave;
